import React from 'react';

const TagsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 4.16797L17.75 9.41797C17.9365 9.60378 18.0844 9.82456 18.1853 10.0677C18.2863 10.3108 18.3382 10.5714 18.3382 10.8346C18.3382 11.0979 18.2863 11.3585 18.1853 11.6016C18.0844 11.8447 17.9365 12.0655 17.75 12.2513L14.1667 15.8346"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.98964 4.6563C7.67715 4.34372 7.25329 4.16806 6.8113 4.16797H2.5013C2.28029 4.16797 2.06833 4.25577 1.91205 4.41205C1.75577 4.56833 1.66797 4.78029 1.66797 5.0013V9.3113C1.66806 9.75329 1.84372 10.1771 2.1563 10.4896L6.90964 15.243C7.2884 15.6193 7.80067 15.8306 8.33464 15.8306C8.8686 15.8306 9.38087 15.6193 9.75964 15.243L12.743 12.2596C13.1193 11.8809 13.3306 11.3686 13.3306 10.8346C13.3306 10.3007 13.1193 9.7884 12.743 9.40964L7.98964 4.6563Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.41667 8.33333C5.64679 8.33333 5.83333 8.14679 5.83333 7.91667C5.83333 7.68655 5.64679 7.5 5.41667 7.5C5.18655 7.5 5 7.68655 5 7.91667C5 8.14679 5.18655 8.33333 5.41667 8.33333Z"
      fill="black"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TagsIcon;
